import { useEffect, useRef, useState } from "react";

const GLYPHS = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789#%&$/<>";
const rand = () => GLYPHS[Math.floor(Math.random() * GLYPHS.length)];
const scramble = (t, settled) => t.split("").map((c, k) => (k < settled || !/[A-Z]/.test(c) ? c : rand())).join("");

const useDecode = (ref, texts) => {
  const [out, setOut] = useState(texts);
  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    let timer;
    const run = () => {
      clearInterval(timer);
      const start = performance.now();
      timer = setInterval(() => {
        const settled = Math.floor((performance.now() - start - 250) / 55);
        setOut(texts.map((t) => scramble(t, settled)));
        if (settled > Math.max(...texts.map((t) => t.length))) { clearInterval(timer); setOut(texts); }
      }, 60);
    };
    let armed = true;
    const io = new IntersectionObserver(([e]) => {
      if (!e.isIntersecting) { armed = true; return; }
      if (armed && e.intersectionRatio >= 0.4) { armed = false; run(); }
    }, { threshold: [0, 0.4] });
    io.observe(ref.current);
    return () => { io.disconnect(); clearInterval(timer); };
  }, [ref, texts]);
  return out;
};

const DESK = ["QUANT EDGE, SIMPLIFIED."];
const MOB = ["QUANT EDGE,", "SIMPLIFIED."];

const Line = ({ text, label, vb = 1000, tone, id }) => (
  <svg viewBox={`0 0 ${vb} 64`} className="block w-full" role="img" aria-label={label}>
    <defs>
      <linearGradient id={`fm-${id}`} x1="0" y1="0" x2="0" y2="1">
        <stop offset="0" stopColor="#ECEBE4" stopOpacity={tone === "solid" ? 0.92 : 0.16} />
        <stop offset="1" stopColor="#ECEBE4" stopOpacity={tone === "solid" ? 0.92 : 0.03} />
      </linearGradient>
    </defs>
    <text x="2" y="52" textLength={vb - 4} lengthAdjust="spacing" fill={`url(#fm-${id})`}
      style={{ fontFamily: "'Space Grotesk', sans-serif", fontWeight: 600, fontSize: 60 }}>
      {tone === "dot" ? <>{text.slice(0, -1)}<tspan fill="#BACD1C" fillOpacity="0.55">.</tspan></> : text}
    </text>
  </svg>
);

export const FooterMark = ({ tone = "faint", haze = false, id = "main" }) => {
  const ref = useRef(null);
  const [d] = useDecode(ref, DESK);
  const [m1, m2] = useDecode(ref, MOB);
  return (
  <div ref={ref} data-testid="footer-mark" className="relative mt-14">
    {haze && (
      <div className="pointer-events-none absolute -inset-x-12 -bottom-20 -top-48 [transform:translateZ(0)]" aria-hidden="true">
        <div className="absolute bottom-0 right-[-6%] h-[360px] w-[55%] rounded-full bg-[#7B5CFF]/[0.09] blur-[110px]" />
        <div className="absolute bottom-10 right-[20%] h-[180px] w-[20%] rounded-full bg-[#BACD1C]/[0.05] blur-[90px]" />
      </div>
    )}
    <div className="relative hidden sm:block"><Line text={d} label="Quant edge, simplified" tone={tone} id={`${id}-d`} /></div>
    <div className="relative space-y-2 sm:hidden">
      <Line text={m1} label="Quant edge," vb={560} tone={tone} id={`${id}-m1`} />
      <Line text={m2} label="simplified" vb={560} tone={tone} id={`${id}-m2`} />
    </div>
  </div>
);
};
